var exports = {
  "iE": "x2b2fbebb--c0e9b2--wrapper",
  "kL": "x2b2fbebb--c0e9b2--container",
  "AS": "x2b2fbebb--c0e9b2--item",
  "UE": "x2b2fbebb--c0e9b2--arrow",
  "qY": "x2b2fbebb--c0e9b2--left-arrow",
  "JO": "x2b2fbebb--c0e9b2--right-arrow",
};

module.exports = exports;
